import React from 'react';
import { Box, CircularProgress, Alert } from '@mui/material';
import { useManifiestos } from '../../hooks/useManifest';
import ManifestDetail from '../../components/administration/manifests/ManifestDetail'
import { useParams } from "react-router-dom";

const ManifiestoDetallesPage = () => {
    const { manifestId } = useParams();
    const { manifiestos, isLoading, error } = useManifiestos(manifestId);


    if (isLoading) return <CircularProgress />;
    if (error) return <Alert severity="error">Error al cargar manifiesto detalle.</Alert>;

    return (
        <Box sx={{ p: 2 }}>
            <ManifestDetail
                windows={manifiestos}
                onReorder={(newOrder) => {
                    console.log('Nuevo orden de manifiesto detalle:', newOrder);
                }}
            />
        </Box>
    );
};

export default ManifiestoDetallesPage;